export enum PaymentOptionsEnum {
  Kidney = "Kidney",
  Gcash = "Gcash",
  OnlineBankTransfer = "Online Bank Transfer",
  Paymongo = "Paymongo",
  COD = "COD",
}
